import type { ReactNode } from 'react';

/**
 * Checks if children is defined. If children is an array,
 * it will check if atleast one child is not undefined.
 * @param children The children, being a single child or an array of children
 * @returns Boolean with the result
 */
export function isChildrenDefined(children: ReactNode): boolean {
  if (Array.isArray(children)) {
    return children.some(isNotNullish);
  }
  return isNotNullish(children);
}

function isNotNullish(children: ReactNode) {
  return children !== undefined && children !== null && children !== false;
}
